import { Schema, number, array, string } from 'lib/schema';

export default class ShowEpisodes extends Schema {
  @string id = { default: null };

  @number total = { default: 0 };

  @array items = { default: () => [] };
}
